// The question in two columns on a desktop (26 Oct 2026): the case (stem, graphic, clues) on the left, the answers on the
// right. Only the player's question screen asks for it (screens/parts/Screen provides WideContext); everywhere else,
// and always on a phone, a view's parts follow one another exactly as before, with no wrapper.
import { createContext, useContext, type ReactNode } from 'react';

export const WideContext = createContext(false);
/** Whether this format shows in two columns: the desktop question screen, never in classroom mode. */
export const useWide = (display?: 'phones' | 'screen'): boolean => useContext(WideContext) && display !== 'screen';

/** The case and the answers: side by side when `wide` and there are answers to place, else one after the other. */
export function Split({ wide, left, right }: { wide: boolean; left: ReactNode; right?: ReactNode }) {
  if (!wide || !right) return <>{left}{right}</>;
  return (
    <>
      <div className="fx-col" data-col="case">{left}</div>
      <div className="fx-col" data-col="answers">{right}</div>
    </>
  );
}
